<template>
  <div class="table">
      <el-table
        :data="orders.list"
        stripe
        :class="{ border: orders.border} "
        style="width: 100%;marginBottom:32px">
        <el-table-column
          v-for="(item, idx) in tabelHead"
          :key="idx"
          :prop="item.value"
          :label="item.label"
          >
        </el-table-column>
        <el-table-column
          v-if="showButton"
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="onDetail(scope.row)"
              type="text"
              size="small">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
       <el-pagination
          v-if="orders.total"
          background
          layout="prev, pager, next"
          :total="orders.total"
          :page-size="orders.pageSize"
          :current-page="orders.pageNum"
          @current-change="setPageNum"
        >
        </el-pagination>
    </div>
</template>
<script>

export default {
  name: 'orders',
  props: {
    orders: {
      type: Object,
      default: () => ({})
    },
    tabelHead: {
      type: Array,
      default: () => ([])
    },
    showButton: {
      type: Boolean,
      default: false
    },
    onSearch: {
      type: Function
    }
  },
  methods: {
    setPageNum (pageNo) {
      this.onSearch({ pageNo })
    },
    onDetail (record) {
      this.$router.push({ path: `/sallData/saleAfter/${record.id}` })
    }
  }
}
</script>
<style scoped lang="scss">
  .table{
    .el-table{
      margin-top:18px;
      .el-table__header-wrapper{
        .el-table__header{
          thead{
            th{
              background-color: red;
              background-color: #f8f8f8;
            }
          }
        }
      }
      &.border{
        border:1px solid #E8E8E8;
      }
      .el-table__body-wrapper{
        margin-bottom: 20px;
      }
      .el-pagination{
        margin-top:32px;
      }
      .el-table__body{
        .el-button--small{
          font-size: 14px;
        }
      }
    }
  }
</style>
